export enum AuthSources {
    PWD,
    EXT,
}
